import Alpine from 'alpinejs'
import {round} from "@popperjs/core/lib/utils/math";

Alpine.data('slider', (slidesSelector=':scope>li') => ({
    
    sliderRect: null,
    sliderMaxScrollLeft: null,
    firstSlide: null,
    lastSlide: null,
    currentSlide: null,
    scrollLeft: null,
    hasPrev: false,
    hasNext: false,
    
    init() {
        const slides = Array.prototype.slice.call(this.$refs.container.querySelectorAll(slidesSelector))
        if(slides.length === 0) {
            return
        }
        this.firstSlide = slides[0]
        this.currentSlide = 0;
        this.lastSlide = slides[slides.length-1]
        this.resize()
        window.addEventListener('resize', () => this.resize())
        this.$refs.container.addEventListener('scroll', () => this.scrollLeft=this.$refs.container.scrollLeft, { passive:true })
        this.$watch('scrollLeft', () => this.scroll())
    },
    
    scroll() {
        this.hasNext = this.lastSlide && this.lastSlide.getBoundingClientRect().right > this.sliderRect.right+5
        this.hasPrev = this.firstSlide && this.firstSlide.getBoundingClientRect().left < this.sliderRect.left-5
        this.currentSlide = round((this.$refs.container.scrollLeft+1)/this.sliderRect.width);
    },
    
    resize() {
        this.scrollLeft = this.$refs.container.scrollLeft
        this.sliderRect = this.$refs.container.getBoundingClientRect()
        this.sliderMaxScrollLeft = Math.ceil((this.lastSlide.getBoundingClientRect().right - this.firstSlide.getBoundingClientRect().left) - this.sliderRect.width)
        this.scroll()
    },

    prevStage() {
        if(!this.hasPrev) {
            return
        }
        this.$refs.container.scrollLeft = Math.max(0, this.$refs.container.scrollLeft - this.sliderRect.width)
        this.scroll()
    },

    nextStage() {
        if(!this.hasNext) {
            return
        }
        this.$refs.container.scrollLeft = Math.min(this.sliderMaxScrollLeft, this.$refs.container.scrollLeft + this.sliderRect.width)
        this.scroll()
    },

    scrollToStage(slide) {
        this.$refs.container.scrollLeft = slide * this.sliderRect.width;
    },
    
    prevItem(scrollBy=1) {
        if(!this.hasPrev) {
            return
        }
        this.$refs.container.scrollLeft = Math.max(0, this.$refs.container.scrollLeft - this.firstSlide.getBoundingClientRect().width * scrollBy)
        this.scroll()
    },
    
    nextItem(scrollBy=1) {
        if(!this.hasNext) {
            return
        }
        this.$refs.container.scrollLeft = Math.min(this.sliderMaxScrollLeft, this.$refs.container.scrollLeft + this.lastSlide.getBoundingClientRect().width * scrollBy)
        this.scroll()
    },

}))